import React from "react";
import { Box, Typography, Divider, Chip } from "@mui/material";

import default_theme from "assets/themes/themes";

const SolutionDetailSidebarRDD = ({ data, styles }) => {
    if (!data.rdd_1 && !data.rdd_2 && !data.rdd_3) {
        return null;
    }

    return (
        <>
            <Divider sx={{ my: 2 }} />

            <Typography
                sx={{ fontWeight: "bold" }}
                variant="h6"
                className={styles.sidebarTitle}
            >
                Rural Development Drivers
            </Typography>

            <Box className={styles.rddContainer}>
                {data.rdd_1 && (
                    <Chip
                        label={data.rdd_1}
                        size="small"
                        className={styles.rddChip}
                        sx={{
                            backgroundColor: default_theme.palette.other.paleGreen,
                            mb: 1,
                        }}
                    />
                )}

                {data.rdd_2 && (
                    <Chip
                        label={data.rdd_2}
                        size="small"
                        className={styles.rddChip}
                        sx={{
                            backgroundColor: default_theme.palette.other.lightBlue,
                            mb: 1,
                        }}
                    />
                )}

                {data.rdd_3 && (
                    <Chip
                        label={data.rdd_3}
                        size="small"
                        className={styles.rddChip}
                        sx={{
                            backgroundColor: default_theme.palette.other.lightOrange,
                            mb: 1,
                        }}
                    />
                )}
            </Box>
        </>
    );
};

export default SolutionDetailSidebarRDD;